import React from 'react';

import {
  CREATIVE_TYPE_BANNER,
  CREATIVE_TYPE_CINEMAGRAPH,
  CREATIVE_TYPE_GIF,
  CREATIVE_TYPE_PLAYABLE,
  CREATIVE_TYPE_VIDEO,
} from 'scenes/Gallery/GalleryPage/constants';

import Container from '../components/Container';
import Iframe from '../components/Iframe';
import Image from '../components/Image';
import Video from '../components/Video';
import useSizes from '../hooks/useSizes';

const DetailsFile = ({
  src,
  width: originalWidth,
  height: originalHeight,
  maxWidth: originalMaxWidth,
  maxHeight: originalMaxHeight,
  creativeTypeId,
  attributes,
  variant,
}) => {
  const { width, height, maxWidth, maxHeight } = useSizes({
    originalWidth,
    originalHeight,
    originalMaxWidth,
    originalMaxHeight,
  });

  switch (creativeTypeId) {
    case CREATIVE_TYPE_VIDEO:
    case CREATIVE_TYPE_CINEMAGRAPH: {
      return (
        <Container attributes={attributes} variant={variant}>
          <Video
            src={src}
            width={width}
            height={height}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        </Container>
      );
    }

    case CREATIVE_TYPE_PLAYABLE: {
      return (
        <Container attributes={attributes} variant={variant}>
          <Iframe
            src={src}
            width={width}
            height={height}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        </Container>
      );
    }

    case CREATIVE_TYPE_BANNER:
    case CREATIVE_TYPE_GIF: {
      return (
        <Container attributes={attributes} variant={variant}>
          <Image
            src={src}
            width={width}
            height={height}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        </Container>
      );
    }

    default: {
      return null;
    }
  }
};

export default DetailsFile;
